import logo from './logo.svg';
import './App.css';
import { BrowserRouter, Route, Routes} from 'react-router-dom';
import Home from './Pages/HomePage/Home/Home';
import Project from './Pages/ProjectPage/Project/Project';
import Blog from './Pages/BlogPage/Blog/Blog';
import Aos from 'aos';
import { useEffect } from 'react';

function App() {
  useEffect(()=>{
    Aos.init()
  },[])
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path='/' element={<Home/>}/>
          <Route path='/home' element={<Home/>}/>
          <Route path='/blogs' element={<Blog/>}/>
          <Route path='/project/:id' element={<Project/>}/>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
